import { render, staticRenderFns } from "./userStatisticsChannelList.vue?vue&type=template&id=042aa4a9&scoped=true&"
import script from "./userStatisticsChannelList.vue?vue&type=script&lang=js&"
export * from "./userStatisticsChannelList.vue?vue&type=script&lang=js&"
import style0 from "./userStatisticsChannelList.vue?vue&type=style&index=0&id=042aa4a9&lang=less&scoped=true&"
import style1 from "./userStatisticsChannelList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042aa4a9",
  null
  
)

export default component.exports